import React, {useEffect, useMemo} from 'react';
import {isEmpty, keyBy} from 'lodash';
import AppliedItemCache from "../../../models/AppliedItemCache";
import {groupItemsSlice} from "../../../../ReduxStore/ProductGroupPage/groupItemsSlice";
import {getDispatch} from "../../../../Utility/ReduxHelper";
import ItemClusterUi from "./ItemClusterUi";
import {getSiteComponent} from "../../../../Utility/componentRegistry";

/**
 * 2025-03 converted from class to function, split off ItemClusterUI
 *
 * ItemCluster - a group of selectors for choosing among
 * a group of items, by their attributes (which may include fitment).
 *
 * PROPS: ["items","dispatch","cluster","clusterState", "multi_add"]
 */

export default function ItemCluster({
  cluster, allClusterStates, products, itemApplications, shoppingCart, dispatch,
  sectionConfig = {},
  productAttributes={}, // NEW 2025-06, pass in attribute info so we control presentation
  // pagetype
  ...props
}) {
  const clusterId = cluster?.id;

  const itemCache = useMemo(() => {
    return new AppliedItemCache({
      apps: itemApplications, products: products
    });
  }, [products])

  const clusterState = allClusterStates ? allClusterStates[clusterId] : null;

  // 2025-06 move this into an Effect
  useEffect(() => {
    if (isEmpty(clusterState) && !isEmpty(products)) {
      // console.log(`INIT CLUSTER STATE - ${clusterId}`);

      let stuff = {clusterId, clusterState: buildClusterState(cluster)};
      dispatch ||= getDispatch();
      dispatch(groupItemsSlice.actions.updateClusterState(stuff));
    }
  }, [clusterState, products, cluster]);

  if (isEmpty(clusterState) && !isEmpty(products)) {
    return null; // and hope it's there on next refresh
  }

  const cartItem = getSelectedCartItem({clusterState, shoppingCart});

  // ItemClusterUI is one of:
  //    ItemClusterUi -- aag etc.
  //    ToolItemClusterUi - carlyle
  const MyUI = getSiteComponent('ItemClusterUi', ItemClusterUi);

  return <MyUI
    cluster={cluster}
    clusterState={clusterState}
    products={products}
    itemCache={itemCache}
    cartItem={cartItem}
    sectionConfig={sectionConfig}
    productAttributes={productAttributes}
  />
}

function getSelectedCartItem({clusterState, shoppingCart}) {
  if (isEmpty(clusterState) || isEmpty(shoppingCart))
    return null;

  const cartIndex = keyBy(shoppingCart.cartItems, 'productId');

  const {selectedItem} = clusterState;
  if (selectedItem) {
    const productId = selectedItem.product?.id;
    return productId ? cartIndex[productId] : null;
  }
  return null;
}

function buildClusterState(cluster) {
  let data = _.merge({clusterId: cluster.id},
    _.pick(cluster, 'levels'));

  // at first, all products match.
  data.matchingProducts = cluster.productIndex;

  return {
    selections: {},
    matchingProducts: cluster.productIndex,
    selectedItem: null,
    levelOptions: {},
    highlighted: false
  }
}
